import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { CustomUserGetParams } from 'src/typings/forms';

export const COOKIE_KEY: string = 'flatShowParams';
export const useCustomGetParams = () => {
  useEffect(() => {
    const params = getCustomParamsObj(CustomUserGetParams);
    if (Object.keys(params).length) {
      Cookies.remove(COOKIE_KEY, { path: '/' });
    }
    Cookies.set(COOKIE_KEY, JSON.stringify(params), {
      expires: 30,
      path: '/',
    });
  }, []);

  const getCustomParamsObj = (params: string[]) => {
    let searchParams: URLSearchParams;
    if (window.realClientPageUrl !== 'CLIENT_PAGE_URL') {
      searchParams = getSearchParams(window.realClientPageUrl);
    } else {
      const { hash } = window.location;
      const queryString = hash.includes('?') ? hash.split('?')[1] : '';
      searchParams = getSearchParams(queryString);
    }
    return Object.fromEntries(
      params
        .filter((key) => searchParams.has(key))
        .map((key) => [key, searchParams.get(key)]),
    );
  };

  const getSearchParams = (value: string): URLSearchParams => {
    try {
      return new URL(value).searchParams;
    } catch {
      return new URLSearchParams(value);
    }
  };

  return {
    CustomUserGetParams,
  };
};

export const getCustomParamsFromCookie = (): Record<string, string> | null => {
  const raw = Cookies.get(COOKIE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
